<template>
  <div class="communicationAgreement">
    <modal :title="$t('texts.communicationModelHeader')" :width="450" :is-show="itemDetailShow" :show-footer=false transition="fadeDown" @close="itemDetailShow=false">
      <div class="is-center">
        <div style="margin:0px 30px 20px;">{{ $t("links.allowingDataForContact") }}</div>
      </div>
    </modal>
    <checkbox v-if="!isRequired" v-model='communicationChecked' :val=true name="hasCommRequestAllowed" v-on:click.stop.prevent="itemDetailShow = true" :disabled="isDisabled"><a v-on:click.stop.prevent="itemDetailShow = true" v-bind:class="{'a-disabled': isDisabled}">{{ $t('links.communicationAgreement') }}</a> {{ $t("links.read") }}.</checkbox>
    <template v-if="isRequired">
      <label v-bind:class="{'on': communicationChecked, 'disabled': isDisabled}" class="checkbox blu-checkbox is-primary">
        <input type="checkbox" v-model='communicationChecked' :val=communicationChecked v-bind:disabled="isDisabled" name="commRequestAllowed" v-validate="'required'" data-vv-validate-on="change|custom">
        <span v-bind:class="{'disabled': isDisabled}"><a v-bind:class="{'a-disabled': isDisabled}" v-on:click.stop.prevent="itemDetailShow = true">{{ $t('links.communicationAgreement') }}</a> {{ $t("links.read") }}.</span>
        <span v-if="errors.has('commRequestAllowed')" class="help is-danger">{{ $t('errors.kvkkCheckBoxError') }}</span>
      </label>
    </template>
  </div>
</template>


<script>
export default {
  name: 'CommunicationAgreement',
  data () {
    return {
      itemDetailShow: false,
      communicationChecked: this.isCommunicationChecked
    }
  },
  inject: [ 'parentValidator' ],
  created () {
    this.$validator = this.parentValidator
  },
  props: {
    isCommunicationChecked: {
      type: Boolean
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    communicationChecked: function () {
      this.$emit('input', this.communicationChecked)
    }
  }
}
</script>

<style scoped>
a {
  text-decoration: underline;
  font-size: 1em;
  font-weight: bold;
  color: var(--text-color9);
}
.communicationAgreement {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/shared/widget/legalInfo/agreement/communication.vue